export default __webpack_public_path__ + "static/media/IconforFooter.1f33af72.png";